module.exports = __webpack_public_path__ + "static/media/travisgo_mobile_bg_businesspartner.3f70540a.webp";